<script setup>
import { computed, toRef } from 'vue';
import ChannelIcon from './ChannelIcon.vue';

// SVG imports — Vite resolves these as URLs
import logoWhatsApp from 'dashboard/assets/icons/logo-whats-oficial-cloud.svg';
import logoWhatsWeb from 'dashboard/assets/icons/logo-whats-web-azul.svg';
import logoMessenger from 'dashboard/assets/icons/logo-messenger.svg';
import logoInstagram from 'dashboard/assets/icons/logo-instagram.svg';
import logoTelegram from 'dashboard/assets/icons/logo-telegram.svg';
import logoTiktok from 'dashboard/assets/icons/logo-tiktok.svg';
import logoApi from 'dashboard/assets/icons/logo-api.svg';
import logoBubbleChat from 'dashboard/assets/icons/logo-bubble-chat.svg';
import logoEmail from 'dashboard/assets/icons/logo-email.svg';
import logoVoice from 'dashboard/assets/icons/logo-voice.svg';

const props = defineProps({
  inbox: {
    type: Object,
    required: true,
  },
});

// Map channel types to colored SVG logos
const COLOR_ICON_MAP = {
  'Channel::Whatsapp': logoWhatsApp,
  'Channel::FacebookPage': logoMessenger,
  'Channel::Instagram': logoInstagram,
  'Channel::Telegram': logoTelegram,
  'Channel::Tiktok': logoTiktok,
  'Channel::Email': logoEmail,
  'Channel::WebWidget': logoBubbleChat,
  'Channel::Voice': logoVoice,
};

// Twilio WhatsApp uses the same WhatsApp icon
const TWILIO_WHATSAPP_ICON = logoWhatsApp;

const svgUrl = computed(() => {
  const inboxData = props.inbox;
  if (!inboxData) return null;

  const type = inboxData.channel_type || inboxData.channelType;

  // Special: Twilio WhatsApp
  if (
    type === 'Channel::TwilioSms' &&
    (inboxData.medium === 'whatsapp' || inboxData.phone_number?.startsWith('whatsapp'))
  ) {
    return TWILIO_WHATSAPP_ICON;
  }

  // Special: WAHA (Channel::Api with platform_type 'whatsapp_web')
  if (type === 'Channel::Api') {
    const pt =
      inboxData.additional_attributes?.platform_type ||
      inboxData.additionalAttributes?.platformType;
    if (pt === 'whatsapp_web') return logoWhatsWeb;
    return logoApi;
  }

  return COLOR_ICON_MAP[type] || null;
});
</script>

<template>
  <img
    v-if="svgUrl"
    :src="svgUrl"
    class="flex-shrink-0 object-contain"
    alt=""
  />
  <!-- Fallback to mono icon when no colored SVG is available -->
  <ChannelIcon v-else :inbox="inbox" />
</template>
